import React from 'react';

export default function LoadingIndicator(props) {
	return (
		<div className="abl-loading">
			Loading...
		</div>
	);
};


/** WEBPACK FOOTER **
 ** ./src/js/components/common/loading_indicator.js
 **/